import { ActionType, CompleteServicesStepPayload } from "../../../AppDataProvider/actions";
import React, { ReactElement, useContext, useEffect } from "react";
import { AppContext } from "../../../AppDataProvider/AppDataProvider";
import { StepContent } from "../StepContent/StepContent";
export function GenericServiceData(): ReactElement {
  const {
    appData,
    appDataDispatch
  } = useContext(AppContext);
  const {
    bookingTool
  } = appData;

  /**
   * Note: the services on this booking tool have been loaded
   * from the organisation in the `GenericBookingToolData` component.
   */
  const {
    forceServiceSelection,
    services
  } = bookingTool;
  useEffect(() => {
    /**
     * If there is only 1 service we need to use the id of that single service.
     * This will be required when the service selection step is disabled.
     *
     * Also, if the service only allows one attendee, or only has one duration,
     * we also need to add those values directly to the bookingData.
     */
    if (services.edges.length === 1 && !forceServiceSelection) {
      const service = services.edges[0].node;
      const payload: CompleteServicesStepPayload = {
        updatedData: {
          service
        }
      };
      appDataDispatch({
        payload,
        type: ActionType.COMPLETE_SERVICES_STEP
      });
    }

    /**
     * If we have been provided a serviceId in the url params,
     * we want to automatically select that service
     */
    const urlParams = new URLSearchParams(window.location.search);
    const preFillServiceId = urlParams.get("serviceId");
    if (services.edges.length > 0 && preFillServiceId) {
      const foundService = services.edges.find(({
        node
      }) => {
        return node._id === preFillServiceId;
      });
      if (foundService) {
        const payload: CompleteServicesStepPayload = {
          updatedData: {
            service: foundService.node
          }
        };
        appDataDispatch({
          payload,
          type: ActionType.COMPLETE_SERVICES_STEP
        });
      } else {
        console.error(`Service with ID ${preFillServiceId} not found.`);
      }
    }
  }, [appDataDispatch, forceServiceSelection, services.edges]);
  return <StepContent services={services} data-sentry-element="StepContent" data-sentry-component="GenericServiceData" data-sentry-source-file="GenericServiceData.tsx" />;
}
export default GenericServiceData;